var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-reviews-summary-count.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"c-product-reviews-summary__section c-product-reviews-summary__section--first\">\n    \n        <div class=\"c-product-reviews-summary__rating-count\">\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "productReviewsAverageRating") > 0) {
output += "\n\n                <span class=\"c-product-reviews-summary__heading\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "roundedAvgRating"), env.opts.autoescape);
output += "</span>\n\n            ";
;
}
output += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "productReviewsTotalResults") > 0) {
output += "\n\n                <span class=\"c-product-reviews-summary__heading c-product-reviews-summary__count\">\n\n                    ";
output += runtime.suppressValue((lineno = 14, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-reviews",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "productReviewsTotalResults")]})])), env.opts.autoescape);
output += "\n\n                </span>\n            \n            ";
;
}
else {
output += "\n\n                <span class=\"c-product-reviews-summary__heading\">";
output += runtime.suppressValue((lineno = 20, colno = 67, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-reviews-empty"])), env.opts.autoescape);
output += "</span>\n\n            ";
;
}
output += "\n        \n        </div>\n\n        <div class=\"c-product-reviews-summary__stars c-product-reviews-summary__icon\">\n\n            <div class=\"c-star-review-outer\">\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "productReviewsAverageRating") > 0) {
output += "\n\n                    <span class=\"c-star-review ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "roundedAvgRatingClass"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue((lineno = 32, colno = 74, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-reviews-stars",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "roundedAvgRating")]})])), env.opts.autoescape);
output += "</span>\n\n                ";
;
}
else {
output += "\n\n                    <span class=\"c-star-review\">";
output += runtime.suppressValue((lineno = 36, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-reviews-stars-empty"])), env.opts.autoescape);
output += "</span>\n\n                ";
;
}
output += "\n\n            </div>\n\n        </div>\n\n    </div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-reviews-summary-count.j2"] , dependencies)